import { PostsAdsForm } from "./posts-ads-form";
import { PostsAdsHandler } from "./posts-ads-handler";
import { PostsAdsListener } from "./posts-ads-listener";

export class PostsAdsSetup {
    private readonly root: HTMLElement;

    private readonly form: PostsAdsForm;

    private readonly handler: PostsAdsHandler;

    private readonly listener: PostsAdsListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new PostsAdsForm(root);
        this.handler = new PostsAdsHandler(this.form);
        this.listener = new PostsAdsListener(this.handler);
    }

    public async init(): Promise<void> {
        this.listener.register();
        await this.handler.bootstrapInitial();
    }

    public static init(root: HTMLElement): void {
        if (!(root instanceof HTMLElement)) return;
        if (root.dataset.postsAdsInit === "1") return;
        root.dataset.postsAdsInit = "1";

        const instance = new PostsAdsSetup(root);
        void instance.init();
    }
}
